import React from 'react'
import BlurOnOutlinedIcon from '@material-ui/icons/BlurOnOutlined'
import DonutLargeIcon from '@material-ui/icons/DonutLarge'
import {
  Link,
  IconButton,
  List,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import PowerSettingsNewOutlinedIcon from '@material-ui/icons/PowerSettingsNewOutlined'
import ForumIcon from '@material-ui/icons/Forum'
import { Theme } from '../../styles'

const csrfToken = ''

export const GlobalMenuList = () => {
  return (
    <div>
      <Divider />
      <List className="list-style">
        <li>
          <Link className="link-style" href="/portal">
            <ListItem button key="Portal">
              <ListItemIcon className="icon">
                <BlurOnOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Portal" />
            </ListItem>
          </Link>
          <Link className="link-style" href="/portal/forum">
            <ListItem button key="Forum">
              <ListItemIcon className="icon">
                <ForumIcon />
              </ListItemIcon>
              <ListItemText primary="Forum" />
            </ListItem>
          </Link>
        </li>
      </List>
      <Divider />
      <List className="list-style">
        <li>
          <Link className="link-style" href="/processes">
            <ListItem button key="Processes">
              <ListItemIcon className="icon">
                <DonutLargeIcon />
              </ListItemIcon>
              <ListItemText primary="Processes" />
            </ListItem>
          </Link>
          <Divider />
          <ListItem button key="Toggle Theme">
            <ListItemIcon className="icon">
              <Theme />
            </ListItemIcon>
            <ListItemText primary="Toggle Theme" />
          </ListItem>
          <form action="../../../logout" method="POST">
            <input type="hidden" name="_token" value={csrfToken} />
            <ListItem button key="Logout">
              <ListItemIcon className="icon">
                <IconButton
                  style={{ color: '#e3342f', left: '-3px' }}
                  size="small"
                  aria-label="logout"
                  type="submit">
                  <PowerSettingsNewOutlinedIcon />
                </IconButton>
              </ListItemIcon>
              <ListItemText
                style={{ color: '#e3342f', paddingLeft: '0px' }}
                primary="Logout"
              />
            </ListItem>
          </form>
        </li>
      </List>
    </div>
  )
}

export default GlobalMenuList
